import { OpenInNew } from '@mui/icons-material';
import { Link, List, ListItem, ListItemButton, ListItemDecorator } from '@mui/joy';
import { Link as RouterLink } from 'react-router-dom';
import type { ReactElement } from 'react';

const links: { title: string; href: string; external?: boolean }[] = [
  {
    title: 'Privacy policy',
    href: '/legal/privacy-policy',
    external: false,
  },
  {
    title: 'Disclosures',
    href: 'https://genieai.tech/disclosures',
    external: true,
  },
  {
    title: 'Terms of services',
    href: 'https://app.termly.io/document/terms-of-service/39b1df19-508b-4dd4-ae4e-5c08ef51b771',
    external: true,
  },
  {
    title: 'Cookie policy',
    href: 'https://app.termly.io/document/cookie-policy/913138d1-b32a-42bc-a87c-404f027e9f1c',
    external: true,
  },
  {
    title: 'Data Processing Addendum',
    href: 'https://genieai.tech/data-processing-addendum',
    external: true,
  },
  {
    title: 'DSAR',
    href: 'https://app.termly.io/notify/d046bf89-172a-4e50-97d3-c957c40c2058',
    external: true,
  },
];

const TermsAndPolicies = (): ReactElement => {
  return (
    <List>
      {links.map((link) => (
        <ListItem key={link.title}>
          {link.external ? (
            <ListItemButton component={Link} href={link.href} target="_blank">
              <ListItemDecorator>
                <OpenInNew />
              </ListItemDecorator>
              {link.title}
            </ListItemButton>
          ) : (
            <ListItemButton component={RouterLink} to={link.href}>
              {link.title}
            </ListItemButton>
          )}
        </ListItem>
      ))}
    </List>
  );
};

export default TermsAndPolicies;
